// Utility functions for browser push notifications.
export function isIframe() {
    return window.self !== window.top;
}

export function getUserHasHandledPushNotificationDialog() {
    return localStorage.getItem('doNotShowPushNotificationDialogAgain') === 'true';
}

import { getDeploymentConfig } from 'util/util';
import { getFirebaseMessaging } from 'internal/firebase';
import { getPublicWebPushKey } from 'open-modules/zdf/component/notifications/pushnotification';
import { getToken } from 'firebase/messaging';

export function arePushNotificationsHandledOnHostSite() {
    return getDeploymentConfig().pushNotificationsOnParentWindow;
}

export function arePushNotificationsSupported() {
    const deploymentConfig = getDeploymentConfig();
    const browserSupportsPush =
        'Notification' in window && 'serviceWorker' in navigator && 'PushManager' in window;
    if (!deploymentConfig.publicWebPushKey || !browserSupportsPush) return false;
    if (!getFirebaseMessaging()) return false;
    return true;
}

export async function registerBrowserPushNotificationServiceWorkerAsync() {
    try {
        const registration = await window.navigator.serviceWorker.register(
            `/js/zdf/messaging-sw.js`
        );
        return registration;
    } catch (e) {
        console.error('Registration of service worker failed');
        return null;
    }
}

export async function fetchBrowserPushNotificationTokenClientAsync(registration: ServiceWorkerRegistration) {
    const messaging = getFirebaseMessaging();
    return await getToken(messaging, { vapidKey: getPublicWebPushKey(), serviceWorkerRegistration: registration });
}

export async function updateServiceWorkerRegistrationAndFetchTokenAsync() {
    const registration = await registerBrowserPushNotificationServiceWorkerAsync();
    if (!registration) {
        return;
    }
    const token = await fetchBrowserPushNotificationTokenClientAsync(registration);
    if (!token) {
        console.warn('Fetch of token failed');
    }
    return token;
}
